export default "__VITE_ASSET__phcvfPak__"